import LecturePrototypeModuleListResourceModel from '../../generated/types/model/resource/LecturePrototypeModuleListResourceModel';

export default class LecturePrototypeModuleListResourceViewModel extends LecturePrototypeModuleListResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
